export default "__VITE_ASSET__DcPCfZgV__"